import React from 'react';

import ResumesHub from '../../js/pages/ResumesHub';
import PageContainer from '../../js/components/PageContainer';
import {listParam} from '../../js/pages/ResumesHub/constants';
import {loadHubProps, publishedCleanPath} from '../../js/pages/ResumesHub/loadHubProps';

// eslint-disable-next-line react/jsx-props-no-spreading
export default function Page(props) { return <ResumesHub {...props} />; }

Page.getLayout = (page) => (
  <PageContainer>
    {page}
  </PageContainer>
);

/**
 * The hub root and its query form. A selection that has a page of its own
 * lives at the clean path; the query form serves the rest without indexing.
 */
export async function getServerSideProps({req, query}) {
  const companies = listParam(query.company);
  const roles = listParam(query.role);
  const hasFilters = companies.length + roles.length > 0;

  const cleanPath = hasFilters
    ? await publishedCleanPath({companies, roles}).catch(() => null)
    : null;
  if (cleanPath) return {redirect: {destination: cleanPath, permanent: true}};

  const props = await loadHubProps({
    req,
    filters: {companies, roles, levels: []},
    segment: hasFilters ? null : {},
    noindex: hasFilters,
  });
  return {props};
}
